import { render, staticRenderFns } from "./QualityReportShared.vue?vue&type=template&id=4a29f6ae&scoped=true"
import script from "./QualityReportShared.vue?vue&type=script&lang=js"
export * from "./QualityReportShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29f6ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a29f6ae')) {
      api.createRecord('4a29f6ae', component.options)
    } else {
      api.reload('4a29f6ae', component.options)
    }
    module.hot.accept("./QualityReportShared.vue?vue&type=template&id=4a29f6ae&scoped=true", function () {
      api.rerender('4a29f6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/pages/QualityReportShared.vue"
export default component.exports